import {Component, HostListener, OnInit, OnDestroy} from '@angular/core';
import {ButtonComponent} from '../elements/button/button.component';
import {IconComponent} from '../elements/icon/icon.component';
import {Icons} from '../../model/icon';
import {Router, RouterLink} from '@angular/router';
import {Location, NgIf} from "@angular/common";
import {HeaderService} from '../../services/header-service';
import {AirportPanelComponent} from './elements/airport-panel/airport-panel.component';
import {TextsComponent} from '../elements/texts/texts.component';
import {scrollUp} from '../../functions/scroll-up';
import {NotificationStyleService} from '../../services/notification-style-service';
import {MenuService} from '../../services/menu-services';
import {LocalizationService} from '../../services/localization.service';
import {ScrollService} from '../../services/scroll-service';
import {HotelService} from '../../services/hotel-service';
import {ThemeService} from '../../services/theme.service';
import {CountryService} from '../../services/country-service';
import {PaginationParams} from '../../model/pagination';
import { Subscription, interval } from 'rxjs';
import {TokenStorageService} from '../../services/token.storage.service';
import {NavigationService} from '../../services/navigation-service';
import {RouteService} from '../../services/route-service';
import {NewMobileHeaderComponent} from './elements/new-mobile-header/new-mobile-header.component';
import {NewMobileMenuComponent} from './elements/new-mobile-menu/new-mobile-menu.component';
import {SafariStyleService} from '../../services/safari-style.service';

@Component({
  selector: 'app-header',
  imports: [
    ButtonComponent,
    IconComponent,
    RouterLink,
    AirportPanelComponent,
    TextsComponent,
    NgIf,
    NewMobileHeaderComponent,
    NewMobileMenuComponent
  ],
  templateUrl: './header.component.html',
  standalone: true,
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  constructor(protected router: Router,
              public location: Location,
              protected interfaceService: HeaderService,
              protected notificationStyle: NotificationStyleService,
              protected localizationService: LocalizationService,
              protected menuService: MenuService,
              private scroll: ScrollService,
              protected hotelService: HotelService,
              protected themeService: ThemeService,
              protected countryService: CountryService,
              protected routeService: RouteService,
              private tokenStorageService: TokenStorageService,
              public navigationService: NavigationService) {}

  lastScrollTop = 0;
  limit = 0;

  tabHeaderHide: boolean = false;
  showMobHeader: boolean = true;

  params = new PaginationParams({
    sort: '',
    query: '',
    pageSize: 500,
    pageNumber: 0,
  });

  private scrollCheckInterval: any;
  private tokenCheckSubscription?: Subscription;

  @HostListener('window:scroll', [])
  checkPosition() {
    this.onWindowScroll();
    this.onMobScroll();
  }

  onWindowScroll() {
    const path = this.location.path();
    if (path === '/admin') {
      this.interfaceService.setActiveInterface('header-container-white');
      this.showMobHeader = false;
      return;
    }
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const scrollPosition = currentScrollTop + windowHeight;
    const nearBottom = documentHeight - scrollPosition <= 80;
    const hideHeaderThreshold = documentHeight - (windowHeight * 2 - 50);
    const shouldHideHeader = currentScrollTop >= hideHeaderThreshold;
    if (path === '/feedback' || window.location.pathname.startsWith('/hotel/')) {
      this.interfaceService.setActiveInterface('header-container-white');
      this.tabHeaderHide = false;
      this.showMobHeader = true;
      return;
    }
    const isHeaderTransparent = this.interfaceService.getPageInterface() === 'header-transparent';
    this.showMobHeader = !shouldHideHeader;
    if (isHeaderTransparent) {
      this.limit = windowHeight * 2;
      const isTop = currentScrollTop > this.limit - 20;
      this.interfaceService.setActiveInterface(isTop ? 'header-container-white' : 'header-transparent');
      this.notificationStyle.setActiveStyle(this.interfaceService.getActiveInterface() === 'header-transparent' ? 0 : 1);
      if (nearBottom) {
        this.interfaceService.setActiveInterface('header-transparent');
      }
    } else {
      this.interfaceService.setActiveInterface('header-container-white');
      this.notificationStyle.setActiveStyle(1);
      if (this.interfaceService.getHeaderStyle() && scrollPosition >= documentHeight - (windowHeight + 80)) {
        this.interfaceService.setActiveInterface('header-transparent');
      } else if (nearBottom) {
        this.interfaceService.setActiveInterface('header-transparent');
      }
    }
    this.tabHeaderHide = documentHeight - scrollPosition <= windowHeight;
  }

  onMobScroll() {
    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const deviceHeight = window.innerHeight;
    if ((currentScrollTop >= documentHeight - windowHeight * 2) &&
         !window.location.pathname.startsWith('/services/') &&
          !window.location.pathname.startsWith('/feedback')) {
            this.menuService.setMobileStyle('none');
    } else {
      if (this.location.path() === '' || window.location.pathname.startsWith('/services/') || window.location.pathname.startsWith('/feedback/')) {
        if (currentScrollTop > deviceHeight + 61) {
            this.menuService.setMobileStyle('white')
          } else {
            this.menuService.setMobileStyle('transparent');
          }
      } else {
        if (this.location.path() === '/destinations' || this.menuService.getMobileSpecialStyle()) {
          if (currentScrollTop > 15) {
            this.menuService.setMobileStyle('white');
          } else {
            if (this.menuService.getMobileActive() && this.location.path() === '/destinations') {
              this.menuService.setMobileStyle('white');
            } else {
              this.menuService.setMobileStyle('transparent');
            }
          }
        } else {
          if (this.location.path() === '/feedback') {
            if (currentScrollTop > 1) {
              this.menuService.setMobileStyle('black');
              // this.menuService.setMobileStyle('white');
            } else {
              this.menuService.setMobileStyle('white');
            }
          } else {
            this.menuService.setMobileStyle('white');
          }
        }
      }
    }
  }

  private checkTokenValidity(): void {
    const token = this.tokenStorageService.getToken();
    const currentPath = this.location.path();
    if (token && !this.tokenStorageService.isTokenValid()) {
      if (currentPath === '/admin') {
        this.tokenStorageService.logout();
        scrollUp();
        this.router.navigate(['/login']);
      } else {
        this.tokenStorageService.logout();
      }
    }
  }

  getInvert() {
    if (this.menuService.getActive()) {
      return this.themeService.getTheme() != 'black-theme';
    } else {
      if (this.themeService.getTheme() == 'black-theme') {
        return false
      } else {
        return this.interfaceService.getActiveInterface() != 'header-transparent'
      }
    }
  }

  checkLocation() {
    return !(this.router.url.startsWith('/documents'));
  }

  stepBack() {
    window.history.back();
  }

  showBackButton(button: string) {
    switch (button) {
      case 'back':
        return (
          this.interfaceService.getThisHotel() ||
          window.location.pathname.includes('/route/')
        );
      case 'geo':
        return this.interfaceService.getThisHotel();
      case 'map':
        return window.location.pathname.includes('/route/');
      default:
        return false;
    }
  }

  openMap() {
    this.router.navigate( ['/map'] ).then(r => r);
  }

  ngOnInit() {
    this.onWindowScroll();
    this.scrollCheckInterval = setInterval(() => {
      this.checkPosition();
    }, 500);
    this.tokenCheckSubscription = interval(30000).subscribe(() => {
      this.checkTokenValidity();
    });
    this.checkTokenValidity();
    this.countryService.getCountryList(this.params).subscribe((data) => {
      const countries = data.content?.filter((v) => v.displayPage === true) ?? [];
      this.countryService.setAndShuffleCountries(countries);
    });
    this.routeService.getRouteList(this.params).subscribe((data) => {
      const routes = data.content?.filter((v) => v.displayPage === true) ?? [];
      this.routeService.setAndShuffleCountries(routes);
    })
    if (this.interfaceService.getActiveInterface() == 'header-transparent') {
      this.interfaceService.setActiveInterface("header-transparent");
      this.notificationStyle.setActiveStyle(0);
    } else {
      this.interfaceService.setActiveInterface("header-container-white");
      this.notificationStyle.setActiveStyle(1);
    }
  }

  ngOnDestroy() {
    if (this.scrollCheckInterval) {
      clearInterval(this.scrollCheckInterval);
    }
    if (this.tokenCheckSubscription) {
      this.tokenCheckSubscription.unsubscribe();
    }
  }

  up() {
    scrollUp();
    this.scroll.unlockScroll();
    this.hotelService.setActiveInterface(0);
    this.menuService.setActive(false);
  }

  isMap() {
    return (this.location.path() != '/map' && this.location.path() != '/admin');
  }

  getHeaderClass() {
    if (this.location.path() == '/feedback' || this.location.path() == 'admin') {
      this.tabHeaderHide = false;
      return 'header-container-white';
    }
    if (this.interfaceService.getThisHotel()) {
      this.tabHeaderHide = false;
      return 'header-transparent';
    }
    return this.interfaceService.getActiveInterface();
  }

  openMG() {
    return
    // window.open('https://meetplusgreet.com/', '_blank');
  }

  menuList(){
    this.menuService.setMobileListMenu(!this.menuService.getMobileListMenu());
  }

  openWhatsApp() {
    const phoneNumber = '+66991609711';
    const message = 'тест';
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, '_blank');
  }

  goToHome() {
    scrollUp();
    this.menuService.setActive(false);
    this.router.navigate([ '/' ]).then(r => r);
  }

  showMobileHeader(): boolean {
    const currentPath = this.location.path();
    const excludedPaths = [
      '/admin',
      '/documents',
      '/login'
    ];
    const isExcluded = excludedPaths.some(path =>
      currentPath === path || currentPath.startsWith(path + '/')
    );
    return !isExcluded;
  }


  protected readonly Icons = Icons;
  protected readonly event = event;
}
